<!-- Overlay Backdrop -->
@if (isOverlay) {
  <div class="pdf-backdrop" (click)="onBackdropClick()"></div>
}

<div class="pdf-container" [class.overlay-mode]="isOverlay">
  <!-- Glass Controls Header -->
  <div class="glass-panel glass-top">
    <!-- Left: Zoom Controls -->
    <div class="control-group zoom-controls">
      <button class="glass-btn" (click)="zoomOut()" title="Zoom out">
        <span class="mat-icon">zoom_out</span>
      </button>

      <div class="zoom-dropdown">
        <button class="glass-btn zoom-value" (click)="toggleZoomMenu()">
          {{ zoomLabel() }}
          <span class="mat-icon dropdown-arrow">expand_more</span>
        </button>

        @if (showZoomMenu()) {
          <div class="zoom-menu zoom-glass-dropdown" (clickOutside)="showZoomMenu.set(false)">
            <button (click)="setZoom('fit-width')">Fit Width</button>
            <button (click)="setZoom('fit-page')">Fit Page</button>
            <div class="divider"></div>
            <button (click)="setZoom(0.5)">50%</button>
            <button (click)="setZoom(0.75)">75%</button>
            <button (click)="setZoom(1)">100%</button>
            <button (click)="setZoom(1.25)">125%</button>
            <button (click)="setZoom(1.5)">150%</button>
            <button (click)="setZoom(2)">200%</button>
          </div>
        }
      </div>

      <button class="glass-btn" (click)="zoomIn()" title="Zoom in">
        <span class="mat-icon">zoom_in</span>
      </button>

      <button
        class="glass-btn fullscreen-btn"
        (click)="toggleFullscreen()"
        title="Toggle fullscreen"
      >
        <span class="mat-icon">{{ isFullscreen() ? 'fullscreen_exit' : 'fullscreen' }}</span>
      </button>
    </div>

    <!-- Center: Document Title -->
    @if (config.filename) {
      <div class="document-title">{{ config.filename }}</div>
    }

    <!-- Right: Action Controls -->
    <div class="control-group action-controls">
      @if (config.showPrint !== false) {
        <button class="glass-btn" (click)="printPdf()" title="Print">
          <span class="mat-icon">print</span>
        </button>
      }
      @if (config.showDownload !== false) {
        <button class="glass-btn" (click)="downloadPdf()" title="Download">
          <span class="mat-icon">download</span>
        </button>
      }
      @if (isOverlay) {
        <button class="glass-btn" (click)="onClose()" title="Close">
          <span class="mat-icon">close</span>
        </button>
      }
    </div>
  </div>

  <!-- Loading Overlay -->
  @if (isLoading()) {
    <div class="loading-overlay">
      <div class="loading-spinner"></div>
    </div>
  }

  <!-- PDF Canvas Area — ngx-extended-pdf-viewer -->
  <div class="pdf-canvas">
    @if (hasError()) {
      <div class="pdf-error">
        <div class="pdf-error__icon-wrap">
          <span class="mat-icon">link_off</span>
        </div>
        <p class="pdf-error__title">Unable to load document</p>
        <p class="pdf-error__subtitle">
          The file could not be retrieved. It may have moved, expired, or is unavailable.
        </p>
      </div>
    } @else {
      <ngx-extended-pdf-viewer
        [src]="config.src"
        [page]="currentPage()"
        [zoom]="zoomValue()"
        [showToolbar]="false"
        [showSidebarButton]="false"
        [textLayer]="config.renderText ?? true"
        [enablePrint]="false"
        [showPresentationModeButton]="false"
        [showOpenFileButton]="false"
        [showSecondaryToolbarButton]="false"
        [showRotateButton]="false"
        [showHandToolButton]="false"
        [showSpreadButton]="false"
        [showPropertiesButton]="false"
        style="width: 100%; height: 100%"
        (pagesLoaded)="onPagesLoaded($event)"
        (pageRendered)="onPageRendered()"
        (currentPageChanged)="onCurrentPageChanged($event)"
        (pdfLoadingFailed)="onError($event)"
      ></ngx-extended-pdf-viewer>
    }
  </div>

  <!-- Glass Controls Footer -->
  @if (config.showNavigation !== false) {
    <div class="glass-panel glass-bottom">
      <button
        class="glass-btn nav-btn"
        (click)="prevPage()"
        [disabled]="currentPage() <= 1"
        title="Previous page"
      >
        <span class="mat-icon">chevron_left</span>
      </button>

      <div class="page-indicator">
        <input
          type="number"
          [value]="currentPage()"
          (change)="goToPage($event)"
          (keydown.enter)="blurInput($event)"
          min="1"
          [max]="totalPages()"
          class="page-input glass-input"
        />
        <span class="page-separator">/</span>
        <span class="total-pages">{{ totalPages() }}</span>
      </div>

      <button
        class="glass-btn nav-btn"
        (click)="nextPage()"
        [disabled]="currentPage() >= totalPages()"
        title="Next page"
      >
        <span class="mat-icon">chevron_right</span>
      </button>
    </div>
  }
</div>
